module.exports = __webpack_public_path__ + "static/casa2-c77057cf2de23c670619b43dec6caada.png";